import React, { Component } from 'react';
import { connect } from "react-redux";
import { ConfirmationDialog, Loader, PrivatePageRedirect, Tooltip } from "../../components";
import { DetailsList, DetailsListLayoutMode, } from 'office-ui-fabric-react/lib/DetailsList';
import {
  Checkbox,
  IconButton,
  SelectionMode,
  Icon,
  Toggle,
} from "office-ui-fabric-react";
import { activateEmployee, disableEmployee, getEmployees } from "../../actions/user";
import axios from "axios";
import ReactPaginate from 'react-paginate';
import { Paginator, concatEmployeeNameAndLastName, mapColumnsAndChangeDescendingForExpected, setKeyValueForSessionStorage, tryGetValueAsIntegerFromSessionStorage } from '../../service/utils';
import { Link } from 'react-router-dom';
import { employeesActivePageNumberKey } from '../../constants/sessionStorageConstants';
import { sortObjectsWithFieldByAlphabet } from '../../service/filters';
import { setEmployeesDisableFilter } from '../../actions/filters';

const DELETE_ACTION = 'Delete';
const ACTIVATE_ACTION = 'Activate';
const dialogContent = (employee, action) => {
  if (action === DELETE_ACTION) {
    return {
      title: `Disable employee ${employee && (employee.firstName + ' ' + employee.lastName)}`,
      subText:
        'Employee will be disabled, but can be activated again.'
    };
  } else if (action === ACTIVATE_ACTION) {
    return {
      title: `Activate employee ${employee && (employee.firstName + ' ' + employee.lastName)}`,
      subText:
        'Employee will be activated, but can be disabled again.'
    };
  }
}

class EmployeesPage extends Component {

  _openDeleteDialog(employeeToDelete) {
    this.setState({ employeeToAction: employeeToDelete, hideDialog: false, dialogAction: DELETE_ACTION })
  }

  _openActivateDialog(employeeToActivate) {
    this.setState({ employeeToAction: employeeToActivate, hideDialog: false, dialogAction: ACTIVATE_ACTION })
  }

  _setEmployeesToShow(pageNumber, employees = null) {
    if (this.Paginator.array || employees) {
      if (employees) {
        this.Paginator.array = employees;
      }

      let pagesCount = this.Paginator.getPagesCount();
      if (pagesCount !== 0 & pagesCount <= pageNumber) {pageNumber = pagesCount - 1}

      this.setState({ employeesToShow: this.Paginator.getCurrentPage(pageNumber), pageNumber });
    }
  }

  prepareEmployees = (employees) => {
    let filteredEmployees = employees ? employees.filter((e) => this.props.showDisabledEmployees || e.isActive).map(concatEmployeeNameAndLastName) : [];

    if (this.state.nameSorting !== 'none') {
      return sortObjectsWithFieldByAlphabet([...filteredEmployees], this.state.nameSorting === 'descend', "employeeName");
    }
    
    return filteredEmployees;
  };

  handlePageClick({ selected }) {
    setKeyValueForSessionStorage(employeesActivePageNumberKey, selected);
    this._setEmployeesToShow(selected)
  }

  _columns = [
    {
      key: 'staff',
      name: 'Staff',
      maxWidth: 25,
      minWidth: 25,
      onRender: ({ isStaff }) => (
        <Checkbox
          checked={isStaff}
          disabled={true}
        />
      )
    },
    {
      key: 'name',
      name: 'Full name',
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
      headerClassName: 'clickable-column-header',
      isSorted: true,
      isSortedDescending: false,
      onColumnClick: (ev, column) => {
        this.sortEmployeesByFullName(column.isSortedDescending);
      },
      onRender: ({ employeeName, lastName, firstName, image, id }) => {
        return <Link
          style={{ display: 'flex' }}
          to={`./${id}/profile`}
          className="table-link"
        >
          <div className={`employee-image ${image ? '' : 'missing-img'}`}
            style={{
              backgroundImage: 'url(' + (image ? axios.defaults.baseURL + image : '/missing-photo.svg') + ')',
              marginRight: 1 + 'rem'
            }}
          />
          {`${employeeName}`}</Link>;
      },
    },
    {
      key: 'skills',
      name: 'Skills',
      fieldName: 'skills',
      minWidth: 150,
      maxWidth: 350,
      isResizable: true,
      data: 'string',
      onRender: ({ skills }) => {
        const skillsS = skills.map((skill) => skill).join(', ');
        return (
          <Tooltip text={skillsS}>{skillsS}</Tooltip>
        );
      },
      isPadded: true
    },
    {
      key: 'projects',
      name: 'Projects',
      fieldName: 'projects',
      minWidth: 150,
      maxWidth: 350,
      isResizable: true,
      data: 'string',
      onRender: ({ projects }) => {
        const projectsS = projects.map((project) => project).join(', ');
        return (
          <Tooltip text={projectsS}>{projectsS}</Tooltip>
        );
      },
      isPadded: true
    },
    {
      key: 'dob',
      name: 'Birthday',
      fieldName: 'dob',
      minWidth: 95,
      maxWidth: 110,
      isResizable: true,
      data: 'string',
      onRender: ({ dob }) => {
        return <span>{new Date(dob).toDateString()}</span>;
      },
      isPadded: true
    },
    {
      key: 'status',
      name: 'Status',
      maxWidth: 50,
      minWidth: 40,
      onRender: ({ isActive }) => (
        <div>
          <span style={{ color: isActive ? '#0078d4' : '#d13438' }}>
            {isActive ? 'Active' : 'Disabled'}
          </span>
        </div>
      )
    },
    {
      key: 'actions',
      name: 'Actions',
      minWidth: 50,
      maxWidth: 50,
      onRender: (item) => {
        return (<IconButton
          style={{ height: 'auto' }}
          allowDisabledFocus={true}
          menuIcon={{ iconName: 'MoreVertical' }}
          menuProps={this.props.isStaff ? {
            items: [
              {
                key: 'open',
                text: 'Open profile',
                iconProps: { iconName: 'Contact', style: { color: '#000' } },
                onClick: () => this._openEmployeeProfile(item.id)
              },
              {
                key: 'presentation',
                text: 'Show Candidate presentation',
                iconProps: { iconName: 'AccountManagement', style: { color: '#000' } },
                onClick: () => this.props.history.push(`/home/${item.id}/presentation`)
              },
              item.isActive ?
                {
                  key: 'delete',
                  text: 'Disable',
                  iconProps: { iconName: 'Delete', style: { color: '#000' } },
                  onClick: () => this._openDeleteDialog(item)
                } : {
                  key: 'activate',
                  text: 'Activate',
                  iconProps: { iconName: 'UserFollowed', style: { color: '#000' } },
                  onClick: () => this._openActivateDialog(item)
                }
            ],
            directionalHintFixed: true
          } :
            {
              items: [
                {
                  key: 'open',
                  text: 'Open profile',
                  iconProps: { iconName: 'Contact', style: { color: '#000' } },
                  onClick: () => this._openEmployeeProfile(item.id)
                }
              ],
              directionalHintFixed: true
            }
          }
          split={false}
        />);
      },
      isPadded: true
    }
  ];

  state = {
    hideDialog: true,
    employeeToAction: null,
    dialogAction: null,
    employeesToShow: [],
    pageNumber: tryGetValueAsIntegerFromSessionStorage(employeesActivePageNumberKey),
    showDisabled: false,
    nameSorting: 'none'
  };

  Paginator = new Paginator(this.prepareEmployees(this.props.employees));

  componentDidMount() {
    const { user, getEmployees } = this.props;
    if (user && user.isStaff) {
      getEmployees();
    }
    this._setEmployeesToShow(this.state.pageNumber);
  }

  componentDidUpdate(prevProps, prevState) {
    const {pageNumber} = this.state;
    const {showDisabledEmployees, employees} = this.props;
    if (prevProps.employees !== employees || prevProps.showDisabledEmployees !== showDisabledEmployees) {
      let preparedEmployees = this.prepareEmployees(employees);
      this._setEmployeesToShow(pageNumber, preparedEmployees);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { employees } = this.props;

    if ((employees && nextProps.employees)) {
      const { hideDialog } = this.state;
      !hideDialog && this._closeDialog();
    }
  }

  sortEmployeesByFullName(isSortedDescending) {
    const {pageNumber} = this.state;
    const employees = this.Paginator.array;
    if (employees) {
      this._columns = mapColumnsAndChangeDescendingForExpected(this._columns, "name", !isSortedDescending);
      const empl = sortObjectsWithFieldByAlphabet([...employees], isSortedDescending, "employeeName");
      this._setEmployeesToShow(pageNumber, empl);
      this.setState({nameSorting: isSortedDescending ? 'descend' : 'ascend'})
    }
  }

  render() {
    const { hideDialog, employeeToAction, employeesToShow, dialogAction, pageNumber } = this.state;
    const { employees, showDisabledEmployees, setShowDisabled } = this.props;
    return (
      <div className={'page-container'}>
        <PrivatePageRedirect />
        <span className={'page-title'}>Employees</span>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', marginBottom: 1 + 'rem' }}>
          <Toggle
            styles={{ root: { marginBottom: 0 + 'px' } }}
            aria-describedby={'status-tooltip'}
            className={'employee-status-toggle'}
            onText={'Show disabled'}
            offText={'Show disabled'}
            checked={showDisabledEmployees}
            onChanged={(checked) => {
              // this._columns = mapColumnsAndChangeDescendingForExpected(this._columns, "name", false);
              setShowDisabled(checked);
            }}
          />
        </div>
        {
          employees && employeesToShow ?
            <div>
              <DetailsList
                items={employeesToShow}
                columns={this._columns}
                selectionMode={SelectionMode.none}
                layoutMode={DetailsListLayoutMode.justified}
              />
              <ReactPaginate
                previousLabel={(() => (<Icon iconName="ChevronLeft" />))()}
                nextLabel={(() => (<Icon iconName="ChevronRight" />))()}
                breakLabel={'...'}
                pageCount={this.Paginator.getPagesCount()}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick.bind(this)}
                containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
                initialPage={pageNumber}
                forcePage={pageNumber}
              />
            </div> :
            <Loader title="Loading employees..." />
        }
        <ConfirmationDialog
          hidden={hideDialog}
          onCancel={this._closeDialog}
          dialogContentProps={dialogContent(employeeToAction, dialogAction)}
          primaryButtonProps={{
            onClick: () => {
              if (dialogAction === DELETE_ACTION) {
                this.deleteEmployee(employeeToAction.id);
              } else if (dialogAction === ACTIVATE_ACTION) {
                this.activateEmployee(employeeToAction.id);
              }
            },
            text: employeeToAction && employeeToAction.isActive ? 'Disable' : 'Activate',
            iconProps: { iconName: employeeToAction && employeeToAction.isActive ? 'Delete' : 'UserFollowed' }
          }}
        />
      </div>
    );
  }

  deleteEmployee = (employeeId) => {
    this.props.disableEmployee(employeeId);
  };

  activateEmployee = (employeeId) => {
    this.props.activateEmployee(employeeId);
  };

  _closeDialog = () => {
    this.setState({ hideDialog: true });
  };

  _openEmployeeProfile = (employeeId) => {
    this.props.history.push(`./${employeeId}/profile`);
  };
}

const mapStateToProps = ({ user, employees, isStaff, showDisabledEmployees }) => {
  return { user, employees, isStaff, showDisabledEmployees };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEmployees: () => dispatch(getEmployees()),
    disableEmployee: (employeeId) => dispatch(disableEmployee(employeeId)),
    activateEmployee: (employeeId) => dispatch(activateEmployee(employeeId)),
    setShowDisabled: (showDisabled) => dispatch(setEmployeesDisableFilter(showDisabled)),
  };
};

export const Employees = connect(mapStateToProps, mapDispatchToProps)(EmployeesPage);



// WEBPACK FOOTER //
// ./src/pages/employees/employees.js